import { render, staticRenderFns } from "./main.vue?vue&type=template&id=66fcfbad&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style1 from "./main.vue?vue&type=style&index=1&id=66fcfbad&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fcfbad",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66fcfbad')) {
      api.createRecord('66fcfbad', component.options)
    } else {
      api.reload('66fcfbad', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=66fcfbad&scoped=true", function () {
      api.rerender('66fcfbad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/phase2/manager-form/advanced/components/setting-email/main.vue"
export default component.exports